"use client";

import React from "react";
import useTranslationApi from "@/lib/hooks/useTranslationApi";

import LinkElement from "@/components/LinkElement";
import {
	PhoneFilledIcon,
	ReturnIcon,
	ShieldIcon,
	TruckIcon,
} from "@/components/icons";

const translate = {
	product_free_ship: "product_free_ship ",
	product_genuine: "product_genuine ",
	product_change_free: "product_change_free ",
	product_call_buy: "product_call_buy ",
};
function ProductPolicy({ className }: { className?: string }) {
	const { t } = useTranslationApi(Object.values(translate));

	const productPolicies = [
		{
			icon: (
				<TruckIcon className="w-[14px] h-[14px] md:w-7 md:h-7 text-gray-400 md:text-gray-500" />
			),
			content: <>{t(translate.product_free_ship)}</>,
		},
		{
			icon: (
				<ShieldIcon className="w-[14px] h-[14px] md:w-7 md:h-7 text-gray-400 md:text-gray-500" />
			),
			content: t(translate.product_genuine),
		},
		{
			icon: (
				<ReturnIcon className="w-[14px] h-[14px] md:w-7 md:h-7 text-gray-400 md:text-gray-500" />
			),
			content: t(translate.product_change_free),
		},
	];
	return (
		<div className={className}>
			<div className="px-4 py-4 md:pb-0 border-y border-gray-200 md:border-t md:border-b-0 flex md:justify-center justify-between overflow-x-auto hideScrollBarMobile">
				<div className="flex  justify-between gap-[25px] md:gap-[56px]">
					{productPolicies.map((item, index) => {
						return (
							<div
								className="flex items-center flex-shrink-0 gap-[6px] md:gap-1"
								key={index}>
								<span className=" flex-shrink-0 ">{item.icon}</span>
								<span className="  text-[11px] flex-shrink-0 md:text-base text-gray-400 md:text-gray-500">
									{item.content}
								</span>
							</div>
						);
					})}
				</div>
			</div>

			<LinkElement
				href="tel:19000129"
				className="text-center text-red-500 text-sm justify-center mt-4 hidden md:flex items-center uppercase">
				{t(translate.product_call_buy)}
				<p className="flex items-center mr-1">
					<PhoneFilledIcon className="text-red-500" /> 1900 0129
				</p>{" "}
				(9:00-21:00)
			</LinkElement>
		</div>
	);
}

export default ProductPolicy;
